import styled from '@emotion/styled'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import download from 'downloadjs'
import Button from '@components/Button'
import LoadingBubbles from '@components/loading-bubbles'
import React, { useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { TitleThickThin } from '@components/titles'
import { getAllSiteMap, getFileSiteMap } from 'api/sitemap.request'

import type { GetStaticPropsContext, NextPage } from "next";
function PanelPrivate() {
  const [files, setFiles] = useState<string[]>([])
  const fileRequest = useMutation(["getAllSitemap"], getFileSiteMap);

  const { mutate, data } = useMutation(
    ["siteMaps"], getAllSiteMap,
    {
      onSuccess(data: {data:string[]} | any) {
        const siteMapFiles = data.data.map((x: any) => `${x.split("?fileName=")[1]}`)
        setFiles(siteMapFiles);
      },
    }
  );

  const downloadFile = (fileName: string) => {
    fileRequest.mutateAsync(fileName, {
      onSuccess: (v) => {
        download(v?.data, fileName, "text/xml");
      },
    });
  };

  useEffect(() => {
    mutate();
  }, []);

  if (data == undefined) {
    return <LoadingBubbles message="Cargando" />;
  }

  return (
    <Container>
      <TitleThickThin thickTitle="Archivos" thinTitle="Sitemap" />
      <SubContainer className="container">
        {files.map((x: any, i: number) => (
          <div key={i}>
            <Button color="secondary" onClick={() => downloadFile(x)}>
              <span>{x}</span>
              <InsertDriveFileIcon />
            </Button>
          </div>
        ))}
      </SubContainer>
    </Container>
  );
}

export default PanelPrivate;

const Container = styled.div`
  width: 100%;
  background-color: white;
  height: 100vh;
  padding-top: 10vh;
`;

const SubContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`lang/${locale}.json`)).default,
    },
  };
}
